// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qg-0";